import React from 'react';
import { Grid, Box, makeStyles } from '@material-ui/core';
import { X, Check } from 'react-feather';
// Redux Related
import { connect, ConnectedProps } from 'react-redux';
import { RootState } from 'src/store/rootReducer';
import { closeSignatureAlert } from 'src/store/emissionPolicy/actions';

const useStyles = makeStyles(() => ({
  container: {
    minHeight: 56,
    padding: 16,
    borderRadius: 10,
    backgroundColor: '#E8FBF3',
  },
  circle: {
    border: '2px solid #27AE60',
    borderRadius: '50%',
    height: 24,
    width: 24,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: {
    fontWeight: 400,
    fontSize: 15,
    color: '#0C472C',
    textOverflow: 'wrap',
  },
  close: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
}));

export const SignMessage = ({
  closeSignatureAlertAction,
  showSignAlert,
}: Props): JSX.Element => {
  const classes = useStyles();

  if (!showSignAlert) {
    return <div data-testid="empty-message" />;
  }

  return (
    <Grid container className={classes.container} data-testid="full-message">
      <Box display="flex" sx={{ width: '100%' }}>
        <Box sx={{ width: 26, marginRight: 10 }}>
          <Box className={classes.circle}>
            <Check color="#27AE60" size={17} />
          </Box>
        </Box>
        <Box flexGrow={1} className={classes.text}>
          El proceso de la certificación digital ha sido completado con éxito.
        </Box>
        <Box sx={{ width: 26 }}>
          <Box className={classes.close}>
            <X
              data-testid="close-icon"
              color="#27AE60"
              onClick={closeSignatureAlertAction}
            />
          </Box>
        </Box>
      </Box>
    </Grid>
  );
};

export const mapStateToProps = (
  state: RootState,
): {
  showSignAlert: boolean;
} => ({
  showSignAlert: state.emissionPolicy.showSignAlert,
});
const reduxActions = {
  closeSignatureAlertAction: closeSignatureAlert,
};

const connector = connect(mapStateToProps, reduxActions);

type Props = ConnectedProps<typeof connector>;

export default connector(SignMessage);
